// Suppress benign ResizeObserver loop errors globally (must be first)
const _roRe = /ResizeObserver loop/;
window.addEventListener('error', (e) => {
  if (_roRe.test(e.message || '')) { e.stopImmediatePropagation(); e.stopPropagation(); e.preventDefault(); }
});
window.addEventListener('unhandledrejection', (e) => {
  if (typeof e.reason === 'string' && _roRe.test(e.reason)) { e.preventDefault(); }
  if (e.reason instanceof Error && _roRe.test(e.reason.message)) { e.preventDefault(); }
});
const _origOnerror = window.onerror;
window.onerror = function(...args: any[]) {
  if (typeof args[0] === 'string' && _roRe.test(args[0])) return true;
  return _origOnerror ? (_origOnerror as any).apply(this, args) : false;
};

import { createPinia } from "pinia";
import { createApp, defineAsyncComponent, nextTick } from "vue";
import axios, { AxiosError, AxiosResponse } from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import router from "./router";
import Quasar from 'quasar/src/vue-plugin.js';import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import quasarUserOptions from "./quasar-user-options";
import Vue3DraggableResizable from "vue3-draggable-resizable";
//default styles
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
import './styles/roboto.scss'
// @ts-ignore
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import "./styles/app.scss";
import './styles/ble-lite-menu.scss'
import 'swiper/css';
import 'swiper/css/pagination';
import { clickOutside } from "@/directives/clickOutside";
import { imgFade } from "@/directives/imgFade";
import { loadSession, applySession } from "@/composables/useSession";
import { generalStore } from "@/store/general";
import { workerStore } from "@/store/worker";

// глобально зарегистрированные компоненты (из ветки pre)
import AuxSelector from '@/components/common/aux-selector/refactored/components/AuxSelector.vue'
import TagSelector from '@/components/common/aux-selector/refactored/components/TagSelector.vue'
import SimpleSelector from '@/components/common/aux-selector/refactored/components/SimpleSelector.vue'
import ParameterInline from '@/components/multiedit/temporary/ParameterInline.vue'
import BillRow from '@/components/multiedit/temporary/storageshared/BillRow.vue'
import MovementRow from '@/components/multiedit/temporary/storageshared/MovementRow.vue'
import ProjectRow from '@/components/multiedit/temporary/storageshared/ProjectRow.vue'
import QueryTable from '@/components/common/querytable/QueryTable.vue'
import { i18n } from "./i18n";
import ItemAdditionComponent from '@/components/multiedit/temporary/ItemAdditionComponent.vue'
import CounterpartyChangeDialog from '@/components/multiedit/temporary/info-dialogs/CounterpartyChangeDialog.vue'

const app = createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(createPinia())
  .use(Vue3DraggableResizable)
  .use(VueAxios, axios)
  .use(router)
  .use(i18n)
  .directive("columns-resizable", {
    updated(el: any) {},
  })
  .directive('click-outside', clickOutside)
  .directive('img-fade', imgFade)
  .component("VueDatePicker", VueDatePicker)
  .component('item-addition-component', ItemAdditionComponent)
  .component('aux-selector', AuxSelector)
  .component('tag-selector', TagSelector)
  .component('simple-selector', SimpleSelector)
  .component('parameter-inline', ParameterInline)
  .component('bill-row', BillRow)
  .component('project-row', ProjectRow)
  .component('movement-row', MovementRow)
  .component('counterparty-change-dialog', CounterpartyChangeDialog)
  .component('query-table', QueryTable);

app.config.globalProperties.window = window
app.config.globalProperties.document = document
app.provide('axios', app.config.globalProperties.axios)  // provide 'axios'

// main.ts — после всех .use() и .component(), но до .mount()
// app.mixin({
//   beforeCreate() {
//     // Принудительно говорим Vue: этот тег — НЕ нативный кастомный элемент
//     if (this.$options.name === 'AuxSelector' || this.$options.name === 'ParameterInline') {
//       // @ts-ignore
//       delete this.$options._componentTag
//     }
//   }
// })
// app.config.compilerOptions.isCustomElement = (tag) => tag === 'aux-selector' || tag === 'parameter-inline'

// app.config.compilerOptions.isCustomElement = () => true
// app.mixin({
//   beforeCreate() {
//     // Принудительно говорим Vue: эти компоненты — не кастомные элементы
//     const name = this.$options.name
//     if (name === 'AuxSelector' || name === 'ParameterInline') {
//       // @ts-ignore
//       this.$options.__isCustomElement = false
//     }
//   }
// })

// app.config.globalProperties.$resolveDynamic = (name: string) => {
//   return app.component(name) || null
// }

// --- Сохраняем экземпляр $q сразу после установки Quasar ---
const qNotifyInstance = app.config.globalProperties.$q;

axios.interceptors.response.use(
  (response: AxiosResponse) => {
    const statusCode = response.status;

    if ((statusCode && statusCode === 200 || statusCode === 201) && 
        (response.data as any).Code !== 0 && 
        (response.data as any).Code != undefined &&
        (response.data as any).Code != null && ((response.data as any).Message as string).includes('EXCEPTION')) {
      const errorMessage = (response.data as any).Message;
      // Показываем централизованную всплывашку
      console.log(`Ошибка ${statusCode}: ${errorMessage}`);
      // !!! Используем сохраненный экземпляр qNotifyInstance !!!
      if (qNotifyInstance) {
        qNotifyInstance.notify({
          type: 'negative', // Стиль Quasar для ошибок (красный)
          message: `Сообщение для отладки: ${statusCode}: ${errorMessage}`,
          caption: 'Кликните, чтобы закрыть',
          timeout: 5000, // Показ уведомления на 5 секунд
          actions: [{ icon: 'close', color: 'white' }]
        });
      }
    }

    // Если ответ успешен (2xx), просто возвращаем его
    return response;
  },
  (error: AxiosError) => {
    // Если произошла ошибка (не 2xx)
    
    const statusCode = error.response?.status;
    // Используйте вашу логику извлечения сообщения об ошибке из ответа сервера
    const errorMessage = (error.response?.data as any).Message || 'Произошла неизвестная ошибка';

    if (statusCode && statusCode !== 200 && statusCode !== 201) {
      // Красная отладочная плашка показывается только вне прод-сборки. В проде
      // пользователь её не видит, но проброс ошибки ниже сохраняется.
      // !!! Используем сохраненный экземпляр qNotifyInstance !!!
      if (process.env.NODE_ENV !== 'production' && qNotifyInstance) {
        qNotifyInstance.notify({
          type: 'negative', // Стиль Quasar для ошибок (красный)
          message: `Сообщение для отладки: ${statusCode}: ${errorMessage}`,
          caption: 'Кликните, чтобы закрыть',
          timeout: 5000, // Показ уведомления на 5 секунд
          actions: [{ icon: 'close', color: 'white' }]
        });
      }
      
      if (statusCode === 401) {
        // Логика обработки неавторизованного доступа
      }
    }

    // !!! ВАЖНО: Пробрасываем ошибку дальше !!!
    // Это не нарушит вашу текущую логику в сервисах, 
    // где вы делаете return axios.put(...)
    return Promise.reject(error);
  }
);

// in order to get token at start
router.isReady().then(async () => {
    const session = loadSession()
    if (session) {
        applySession(session)
        await generalStore().checkGeneralAccess()
        await workerStore().getWorkerProfile()
    }
    app.mount('#app')
})
